import {makeAutoObservable, runInAction} from 'mobx';
import {CallEventType} from '../App/RealtimeProvider';
import AthenaAPI from '../APIs/AthenaAPI';

export class LiveCallStore {
    currentCall: CallEventType | undefined = undefined;
    messages: CallEventType[] = [];
    isLoading: boolean = false;

    constructor() {
        makeAutoObservable(this, {
            checkActiveCall: false,
        });
    }

    setCurrentCall = (call: CallEventType | undefined) => {
        this.currentCall = call;
    };

    addMessage = (message: CallEventType) => {
        this.messages = [message, ...this.messages];
        this.currentCall = message;
    };

    checkActiveCall = async (agentEmail: string) => {
        runInAction(() => {
            this.isLoading = true;
        });

        try {
            const activeCall = await AthenaAPI.getActiveCall(agentEmail);

            runInAction(() => {
                if (activeCall) {
                    this.currentCall = activeCall;
                }
            });
        } catch (error) {
            console.error('Error checking active call:', error);
        } finally {
            runInAction(() => {
                this.isLoading = false;
            });
        }
    };
}
